/** Renewals due: active members whose membership renews in the next 90 days, by how soon. The number the Renewals report shows. */
import type { PersonLine, ViewDef } from "../views";

/** The three bands, soonest first: the desk stage each comes from, and what a row says. */
export const DUE_BANDS = [
  { stage: "due_30", label: "Within 30 days" },
  { stage: "due_60", label: "31–60 days" },
  { stage: "due_90", label: "61–90 days" },
] as const;

export const RENEWALS: ViewDef = {
  id: "renewals",
  title: "Renewals due",
  paged: false,
  emails: "segment",
  columns: [
    { key: "district", label: "District", kind: "num" },
    { key: "left", label: "Days left", kind: "num", relative: true },
    { key: "due", label: "Due" },
  ],
  empty: "No renewal is due soon.",
};

/** Each band's people, soonest first; a person in two bands (it should not happen) is listed once, in the nearer. */
export function mergeDue(bands: PersonLine[][]): PersonLine[] {
  const byId = new Map<number, PersonLine>();
  bands.forEach((people, i) => {
    for (const p of people) if (!byId.has(p.id)) byId.set(p.id, { ...p, cells: { ...p.cells, due: DUE_BANDS[i]?.label ?? "" } });
  });
  return [...byId.values()];
}
